export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_Message_TO = "SET_Message_TO";
